module.exports = __webpack_public_path__ + "static/media/w1-t.ba3d5377.jpg";